// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import translationEN from './locales/en/translation.json';
import translationDE from './locales/de/translation.json';
import translationAR from './locales/ar/translation.json';
import translationTU from './locales/tr/translation.json';

// Translation resources
const resources = {
    en: { translation: translationEN },
    de: { translation: translationDE },
    ar: { translation: translationAR },
    tr: { translation: translationTU },
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'de',
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
